import { makeStyles } from 'tss-react/mui'
import { fundingColors as C } from '../../theme/fundingColors'
import {
  fundingModalPaper,
  fundingModalTitle,
  fundingModalTitleIcon,
} from '../../theme/fundingSharedStyles'

/** Activity log modal — tokens from fundingColors (Figma 641:7238 layout). */
export const useStyles = makeStyles()(() => ({
  modalOverlay: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 16,
  },
  paper: {
    ...fundingModalPaper,
    height: 444,
    maxHeight: 'min(444px, calc(100vh - 32px))',
    maxWidth: 'calc(100vw - 32px)',
    alignItems: 'flex-start',
    outline: 'none',
    boxShadow: '0px 20px 60px rgba(0,0,0,0.16)',
    overflow: 'hidden',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 16,
    width: '100%',
    height: 28,
    flexShrink: 0,
  },
  titleRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 16,
  },
  iconTile: {
    ...fundingModalTitleIcon,
  },
  title: {
    ...fundingModalTitle,
  },
  close: {
    border: 'none',
    background: 'none',
    width: 24,
    height: 24,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: C.mutedText,
    fontSize: 24,
    lineHeight: 1,
    padding: 0,
    cursor: 'pointer',
    flexShrink: 0,
    '&:hover': { opacity: 0.8 },
  },
  timeline: {
    position: 'relative',
    flex: 1,
    alignSelf: 'stretch',
    width: '100%',
    minHeight: 0,
    overflowY: 'auto',
    overflowX: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    scrollbarWidth: 'thin',
    scrollbarColor: `${C.activityScrollbar} transparent`,
    '&::-webkit-scrollbar': { width: 8 },
    '&::-webkit-scrollbar-thumb': {
      background: C.activityScrollbar,
      borderRadius: 4,
    },
    '&::-webkit-scrollbar-track': { background: 'transparent' },
  },
  timelineRail: {
    position: 'absolute',
    left: 18,
    top: 10,
    bottom: 0,
    width: 1,
    background: C.activityRail,
    pointerEvents: 'none',
  },
  group: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    width: '100%',
    position: 'relative',
    zIndex: 1,
  },
  groupHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    width: '100%',
    height: 22,
  },
  groupSpacer: {
    width: 38,
    height: 22,
    flexShrink: 0,
  },
  groupLabel: {
    fontSize: 11,
    fontWeight: 500,
    lineHeight: '16px',
    letterSpacing: 0.8,
    textTransform: 'uppercase',
    color: C.activityGroupLabel,
    whiteSpace: 'nowrap',
  },
  groupRule: {
    flex: 1,
    height: 1,
    minWidth: 0,
    background: C.activityGroupRule,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 16,
    width: '100%',
    minHeight: 38,
  },
  toneIcon: {
    width: 38,
    height: 38,
    borderRadius: '50%',
    border: `2px solid ${C.onPrimary}`,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    fontSize: 16,
    boxSizing: 'border-box',
    background: C.activityNeutralIcon,
    color: C.mutedText,
  },
  toneOk: {
    background: C.successContainer,
    color: C.successOnContainer,
  },
  toneBad: {
    background: C.archiveBannerBg,
    color: C.errorOnContainer,
  },
  toneEdit: {
    background: C.activityNeutralIcon,
    color: C.mutedText,
  },
  body: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
    minHeight: 38,
  },
  main: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    flexWrap: 'wrap',
    minWidth: 0,
    flex: 1,
  },
  avatar: {
    width: 22,
    height: 22,
    borderRadius: '50%',
    background: C.activityAvatar,
    color: C.onPrimary,
    fontSize: 9,
    fontWeight: 600,
    lineHeight: '14px',
    letterSpacing: '0.167px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  actor: {
    fontSize: 13,
    fontWeight: 500,
    lineHeight: '20px',
    color: C.strongText,
    whiteSpace: 'nowrap',
  },
  eventLabel: {
    fontSize: 13,
    fontWeight: 400,
    lineHeight: '20px',
    color: C.activityEventText,
    whiteSpace: 'normal',
    wordBreak: 'break-word',
  },
  detailPill: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 24,
    padding: '4px 8px',
    borderRadius: 23,
    background: C.activityDetailPill,
    color: C.darkText,
    fontSize: 11,
    fontWeight: 500,
    lineHeight: '13px',
    letterSpacing: '0.25px',
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    flexShrink: 0,
  },
  time: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '18px',
    color: C.activityGroupLabel,
    whiteSpace: 'nowrap',
    flexShrink: 0,
  },
  empty: {
    margin: 0,
    fontSize: 14,
    lineHeight: '20px',
    color: C.mutedText,
    paddingLeft: 54,
  },
}))
